import { useState } from 'react';
import type { CSSProperties, ReactNode } from 'react';

export type TooltipSide = 'top' | 'bottom' | 'left' | 'right';

const posicoes: Record<TooltipSide, CSSProperties> = {
    top: { bottom: '100%', left: '50%', transform: 'translate(-50%,-6px)' },
    bottom: { top: '100%', left: '50%', transform: 'translate(-50%,6px)' },
    left: { right: '100%', top: '50%', transform: 'translate(-6px,-50%)' },
    right: { left: '100%', top: '50%', transform: 'translate(6px,-50%)' },
};

export interface TooltipProps {
    label?: ReactNode;
    side?: TooltipSide;
    children?: ReactNode;
    style?: CSSProperties;
}

/** Aparece no hover e também no foco: dica que só responde ao mouse não existe
 *  para quem navega por teclado. Nunca use tooltip como único nome acessível. */
export function Tooltip({ label, side = 'top', children, style }: TooltipProps) {
    const [show, setShow] = useState(false);
    const pos = posicoes[side] ?? posicoes.top;
    return (
        <span
            style={{ position: 'relative', display: 'inline-flex', ...style }}
            onMouseEnter={() => setShow(true)}
            onMouseLeave={() => setShow(false)}
            onFocus={() => setShow(true)}
            onBlur={() => setShow(false)}
        >
            {children}
            {show && (
                <span
                    role="tooltip"
                    style={{
                        position: 'absolute', ...pos, zIndex: 40, background: 'var(--neutral-950)', color: '#fff',
                        fontFamily: 'var(--font-ui)', fontSize: 12, lineHeight: '16px', fontWeight: 500,
                        padding: '5px 8px', borderRadius: 6, whiteSpace: 'nowrap', boxShadow: 'var(--shadow-md)', pointerEvents: 'none',
                    }}
                >
                    {label}
                </span>
            )}
        </span>
    );
}
